module.exports = __webpack_public_path__ + "img/inviteBusiness_carousel.848f06b7.png";